export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/c1-full.5d7d054a.svg","height":90,"width":789,"blurWidth":0,"blurHeight":0};